var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"nbaFlagWrapper"}},[_c('div',{staticClass:"nbaTitle"},[_vm._v("ACC")]),_c('v-icon',{staticClass:"nbaFlagIcon"},[_vm._v("mdi-label-variant")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }